
<template>


<div v-if="microNote">

  <!-- main study area -->
  <div @click.prevent="handleClick" class="panel-body">
    <div class="microNoteImageStudier">


    <div class="image-container">

      <ImageKeyword v-for="keyword in keywords" :scale="scale" :keywordId="keyword.id" />

      <img
        v-if="microNote.micro_note_images"
        ref="image"
        :src="microNote.micro_note_images[0].image_url" />
    </div>


    </div>
  </div>
</div>

</template>

<script>
import Vue from 'vue'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import ImageKeyword from './ImageKeyword'


export default {
  props: ['microNote'],

  components: {
    ImageKeyword,
  },

  created() {
    // Mount the keywords. HTML keywords mount themselves, but in this case we can set them directly
    $(window).on('resize.microNoteImageStudier', _.debounce(() => {
      this.imageDisplayWidth = $('.image-container img').width();
    }, 200));


    this.loadKeywords();
    this.$watch('microNote.keywords', (newVal, oldVal) => {
      // when microNote changes reset keywords
      this.loadKeywords();
    })
  },

  mounted() {
    this.imageDisplayWidth = $('.image-container img').width();
  },

  beforeDestroy() {
    $(window).off('resize.microNoteImageStudier');
  },

  methods: {
    // Resets and loads keywords into diagram
    loadKeywords() {
      console.log('microNoteImageStudier.loadKeywords()')

      // keywords should already be cleared
      // this.$store.commit('studier/RESET_KEYWORDS');

      // Load keywords
      const keywords = _.values(this.microNote.keywords); // obj -> array
      this.keywords = keywords; // #todo - move this below register

      // Register keywords with store
      _.each(keywords, (keyword) => {
        const realAnswer = keyword.value;
        const length = realAnswer.length;
        // const placeholder = "_".repeat(length)
        const placeholder = '';

        // Each keyword register's itself with the store so that they're linked.
        // the ImageKeyword then watches this property (based on the ID)
        this.$store.commit('studier/REGISTER_KEYWORD', {
          keyword: {
            _uid: keyword.id,
            placeholder,
            realAnswer,
            answer: null,
            answered: false,
            correct: false,

            // Position info
            x:      keyword.x,
            y:      keyword.y,
            width:  keyword.width,
            height: keyword.height,
          },
        })
      });


    },


    // Somewhere in the main panel body is clicked
    handleClick(e) {
      const $target = $(e.target);

      // Things to ignore clicking on
      if($target.hasClass('clex-keyword')) return;

      this.$store.dispatch('studier/setActiveKeyword', {keyword: null})
    },
  },

  computed: {
    // Calculate image size / actual image size
    scale() {
      if (!this.microNote || !this.imageDisplayWidth || !this.microNote.micro_note_images[0].image_width) return 1;
      return this.imageDisplayWidth / this.microNote.micro_note_images[0].image_width;
    },

    keywords() {
      return _.values(this.microNote.keywords);
    },
  },

  data() {
    return {
      // allows us to watch window change to calc scale
      imageDisplayWidth: null,

    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.microNoteImageStudier {
  margin-top: 20px;
  text-align: center;
}

.image-container {
  position: relative;
  // border: 5px solid red;
  border: 3px solid #d4d4d4;
  border: 1px solid #404040;
  display: inline-block;
  max-width: 100%;
  min-width: 700px;

  &.creating {
    // border-color: green;
    .keyword {
      pointer-events: none;
    }
  }

  img {
    width: 100%;
    // cursor: crosshair;

    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
}


/**
 * Styling for <keyword> as shown in editor (scoped doesn't work for sum reazon)
 */
keyword {
  background: #fcd45e;
  padding: 5px;
  border-radius: 4px;
}

</style>





// WEBPACK FOOTER //
// MicroNoteImageStudier.vue?20aa95b2